export enum AnnouncementReceiverEnum {
    ALL = "All",
    STANDARD = "Standard",
    ALL_STUDENTS = "All Students",
    SELECTED_STUDENTS = "Selected Students",
    ALL_TEACHERS = "All Teachers",
    SELECTED_TEACHERS = "Selected Teachers",
    DIVISION = "Division",
}

export enum TeacherAnnouncementReceiverEnum {
    ALL = "All",
    SELECTED_STUDENTS = "Selected Students",
}
